import { AuthorizedRoute } from './shared/auth'
import History from './pages/History'
import Home from './pages/Home'
import Layout from './components/Layout'
import Login from './pages/Login'
import Password from './pages/Password'
import { Route } from 'react-router'
import { UserContextProvider } from './shared/user'

const App = () => {
	return (
		<Layout>
			<UserContextProvider>
				<Route exact path='/login' component={Login} />
				<AuthorizedRoute>
					<Route exact path='/' component={Home} />
					<Route exact path='/password' component={Password} />
					<Route exact path='/history' component={History} />
				</AuthorizedRoute>
			</UserContextProvider>
		</Layout>
	)
}
export default App
